// @flow

import React, { Fragment } from "react";

import Product from "./../Product/Product";

type PropsType = {
	products: TopicListProductType[]
};

export const ProductList = (props: PropsType) => (
	<Fragment>
		{props.products.length === 0 ? (
			<span>Sorry, no products could be found with your selected filters.</span>
		) : (
			<ol id="live-products-list" className="list--unstyled mv--0">
				{props.products.map((product, index) =>
					<Product key={`${product.productType.productType}_${product.id}_${product.title}_${product.consultationName}`} index={index} product={product} />
				)}
			</ol>
		)}
	</Fragment>
);

export default ProductList;
